var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgManual(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 20 20",
    width: "20pt",
    height: "20pt"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "manual_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#manual_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeWidth: 3,
    stroke: "#333",
    strokeLinecap: "square",
    strokeMiterlimit: 3,
    d: "M1.367 18.25h14.641M2.768 16.446h11.839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.798 14.536h7.779M8.255 14.213l.872-2.619 2.401-7.201",
    fill: "none",
    vectorEffect: "non-scaling-stroke",
    strokeWidth: 3,
    stroke: "#333",
    strokeLinecap: "square",
    strokeMiterlimit: 3
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 11.723,
    cy: 4.317,
    r: 2.63,
    fill: "#333"
  }))));
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PCEtLSBHZW5lcmF0b3I6IEdyYXZpdC5pbyAtLT48c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHN0eWxlPSJpc29sYXRpb246aXNvbGF0ZSIgdmlld0JveD0iMCAwIDIwIDIwIiB3aWR0aD0iMjBwdCIgaGVpZ2h0PSIyMHB0Ij48ZGVmcz48Y2xpcFBhdGggaWQ9Il9jbGlwUGF0aF9rb3ltTUhYdW5XanVoV1NvV1RpOTQySlY3aXBxSGVmTCI+PHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIi8+PC9jbGlwUGF0aD48L2RlZnM+PGcgY2xpcC1wYXRoPSJ1cmwoI19jbGlwUGF0aF9rb3ltTUhYdW5XanVoV1NvV1RpOTQySlY3aXBxSGVmTCkiPjxnPjxsaW5lIHgxPSIxLjM2NyIgeTE9IjE4LjI1IiB4Mj0iMTYuMDA4IiB5Mj0iMTguMjUiIHZlY3Rvci1lZmZlY3Q9Im5vbi1zY2FsaW5nLXN0cm9rZSIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2U9InJnYig1MSw1MSw1MSkiIHN0cm9rZS1saW5lam9pbj0ibWl0ZXIiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiIHN0cm9rZS1taXRlcmxpbWl0PSIzIi8+PGxpbmUgeDE9IjIuNzY4IiB5MT0iMTYuNDQ2IiB4Mj0iMTQuNjA3IiB5Mj0iMTYuNDQ2IiB2ZWN0b3ItZWZmZWN0PSJub24tc2NhbGluZy1zdHJva2UiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlPSJyZ2IoNTEsNTEsNTEpIiBzdHJva2UtbGluZWpvaW49Im1pdGVyIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIiBzdHJva2UtbWl0ZXJsaW1pdD0iMyIvPjxwYXRoIGQ9IiBNIDQuNzk4IDE0LjUzNiBMIDExLjUzMSAxNC41MzYgTCAxMi41NzcgMTQuNTM2IiBmaWxsPSJub25lIiB2ZWN0b3ItZWZmZWN0PSJub24tc2NhbGluZy1zdHJva2UiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlPSJyZ2IoNTEsNTEsNTEpIiBzdHJva2UtbGluZWpvaW49Im1pdGVyIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIiBzdHJva2UtbWl0ZXJsaW1pdD0iMyIvPjxwYXRoIGQ9IiBNIDguMjU1IDE0LjIxMyBMIDkuMTI3IDExLjU5NCBDIDkuMjQ4IDExLjIzMyAxMC4wNDggOC44MzMgMTEuNTI4IDQuMzkzIiBmaWxsPSJub25lIiB2ZWN0b3ItZWZmZWN0PSJub24tc2NhbGluZy1zdHJva2UiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlPSJyZ2IoNTEsNTEsNTEpIiBzdHJva2UtbGluZWpvaW49Im1pdGVyIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIiBzdHJva2UtbWl0ZXJsaW1pdD0iMyIvPjxjaXJjbGUgdmVjdG9yLWVmZmVjdD0ibm9uLXNjYWxpbmctc3Ryb2tlIiBjeD0iMTEuNzIzMzE1MzI5MjE4MDkyIiBjeT0iNC4zMTcwNjUzMjkyMTgwOTkiIHI9IjIuNjI5NTY1MzI5MjE4MDk5NCIgZmlsbD0icmdiKDUxLDUxLDUxKSIvPjwvZz48L2c+PC9zdmc+";
export { SvgManual as ReactComponent };